import {
  CloseCircleOutlined,
  CloseOutlined,
  InfoCircleOutlined,
  InfoOutlined,
  StarFilled,
} from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { images } from "../assets";
import APIService from "../services/APIService";
import { convertToVnd } from "../utils/function";
import ProductItem from "../components/ProductItem";
import ProductSellingItem from "../components/ProductSellingItem";
import SellingProducts from "../components/SellingProducts";
import { Button, Modal, Pagination } from "antd";
import SImage from "../components/SImage";
export default function AgencyDetailsPage() {
  const [agencyDetails, setAgencyDetails] = useState({});
  const [activeCategory, setActiveCategory] = useState(0);
  const [category, setCategory] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [totalPage, setTotalPage] = useState(0);
  const [page, setPage] = useState(1);
  const [product, setProduct] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const agencyId = searchParams.get("agencyId");
  async function getAgencyDetails(drug_store_id) {
    const RESULT = await APIService.getAgencyDetails(drug_store_id);
    if (RESULT) {
      setAgencyDetails(RESULT);
    }
  }
  useEffect(() => {
    getAgencyDetails(agencyId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [agencyId]);
  async function getAgencyCategory(drug_store_id) {
    const RESULT = await APIService.getAgencyCategory(drug_store_id);
    if (RESULT) {
      setCategory([{ category_name: "Tất cả", category_id: 0 }, ...RESULT]);
    }
  }
  useEffect(() => {
    getAgencyCategory(agencyId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [agencyId]);

  async function getProductAgent(drug_store_id, cate_id) {
    const RESULT = await APIService.getDrugList(
      undefined,
      drug_store_id,
      cate_id,
      page
    );
    if (RESULT) {
      setProduct(RESULT.data);
      setTotalPage(RESULT.total);
    }
  }
  console.log(totalPage);
  useEffect(() => {
    getProductAgent(agencyId, activeCategory);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeCategory, agencyId, page]);

  const onChange = (page) => {
    setPage(page);
    console.log(page);
  };
  return (
    <div className="w-full">
      <div className="h-[300px] rounded-xl mb-5 overflow-hidden hidden sm:block">
        <SImage
          src={agencyDetails.banner}
          className="object-cover w-full h-full"
          alt=""
        />
      </div>
      <div className="flex mb-5">
        <div className="relative flex p-4 bg-white shadow-lg rounded-xl w-full sm:w-auto flex-1.5">
          <div className="sm:basis-[145px] sm:h-[145px] basis-[118px] h-[118px]">
            <SImage
              src={agencyDetails?.avatar}
              className="w-full h-full rounded-xl"
              alt=""
            />
          </div>
          <div className="flex flex-1 flex-col sm:gap-[10px] ml-4">
            <span className="text-[10px] sm:text-base font-bold text-[#222222] not-italic capitalize">
              {agencyDetails?.name}
            </span>
            <span className="text-[10px] sm:text-sm not-italic font-normal capitalize text-[#119AE2]">
              {agencyDetails?.address}
            </span>
            <div className="text-[10px] sm:text-sm flex items-center">
              <span className="font-normal text-[#222222] not-italic capitalize mr-2">
                Đánh giá:
              </span>
              <StarFilled className="text-[#FFC43F] mr-[4px]" />
              <span className="font-semibold">{agencyDetails?.star || 0}</span>
            </div>
            <div className="text-[10px] sm:text-sm flex">
              <span className="font-normal text-[#222222] not-italic capitalize mr-2">
                Giấy phép kinh doanh:
              </span>
              <span className="font-semibold">
                {agencyDetails?.business_license}
              </span>
            </div>
            <div className="flex-col sm:gap-[10px] flex sm:hidden">
              <div className="text-[10px] sm:text-sm flex">
                <span className="font-normal text-[#222222] not-italic capitalize mr-2">
                  Sản Phẩm:
                </span>
                <span className="font-semibold">
                  {agencyDetails?.countDrug} sản phẩm
                </span>
              </div>
              <div className="text-[10px] sm:text-sm flex">
                <span className="font-normal text-[#222222] not-italic capitalize mr-2">
                  Đã bán:
                </span>
                <span className="font-semibold">{agencyDetails?.totalSell}</span>
              </div>
              <div className="text-[10px] sm:text-sm flex">
                <span className="font-normal text-[#222222] not-italic capitalize mr-2">
                  Tham gia:
                </span>
                <span className="font-semibold">{agencyDetails?.join_at}</span>
              </div>
              <div className="text-[10px] sm:text-sm flex">
                <span className="font-normal text-[#222222] not-italic capitalize mr-2">
                  Hotline:
                </span>
                <span className="font-semibold">{agencyDetails?.phone}</span>
              </div>
            </div>
          </div>

        </div>
        <div className="flex-col gap-[10px] ml-[55px] py-4 hidden sm:flex flex-1">
          <div className="flex">
            <span className="text-sm font-normal text-[#222222] not-italic capitalize mr-2">
              Sản Phẩm:
            </span>
            <span className="font-semibold">
              {agencyDetails?.countDrug} sản phẩm
            </span>
          </div>
          <div className="flex">
            <span className="text-sm font-normal text-[#222222] not-italic capitalize mr-2">
              Đã bán:
            </span>
            <span className="font-semibold">{agencyDetails?.totalSell}</span>
          </div>
          <div className="flex">
            <span className="text-sm font-normal text-[#222222] not-italic capitalize mr-2">
              Tham gia:
            </span>
            <span className="font-semibold">{agencyDetails?.join_at}</span>
          </div>
          <div className="flex">
            <span className="text-sm font-normal text-[#222222] not-italic capitalize mr-2">
              Hotline:
            </span>
            <span className="font-semibold">{agencyDetails?.phone}</span>
          </div>
        </div>
        <div className="flex-col gap-[10px] ml-[55px] py-4 hidden sm:flex flex-1">
          <div className="flex">
            <span className="text-sm font-normal text-[#222222] not-italic capitalize mr-2">
              Mô tả:
            </span>
            <span className="font-semibold">
              {agencyDetails?.description}
            </span>
          </div>
          <div className="flex">
            <span className="text-sm font-normal text-[#222222] not-italic capitalize mr-2">
              Thành phố:
            </span>
            <span className="font-semibold">{agencyDetails?.city_name}</span>
          </div>
          <div className="flex">
            <span className="text-sm font-normal text-[#222222] not-italic capitalize mr-2">
              Quận/Huyện:
            </span>
            <span className="font-semibold">{agencyDetails?.district_name}</span>
          </div>
          <div className="flex">
            <span className="text-sm font-normal text-[#222222] not-italic capitalize mr-2">
              Phường/Xã:
            </span>
            <span className="font-semibold">{agencyDetails?.ward_name}</span>
          </div>
        </div>
      </div>
      <ul className="category-filter uppercase flex overflow-scroll items-center text-[10px] sm:text-[16px] mb-4">
        {category.map((item, index) => {
          return (
            <div className="flex flex-row items-center mr-8">
              {item.icon && (
                <img
                  className="w-[33px] h-[33px] mr-4"
                  src={item.icon}
                  alt=""
                />
              )}
              <li
                className={`truncate cursor-pointer py-4 ${item.category_id === activeCategory ? "active" : ""
                  }`}
                onClick={() => setActiveCategory(item.category_id)}
              >
                {item.category_name}
              </li>
            </div>
          );
        })}
      </ul>
      <div className="grid grid-cols-2 md:grid-cols-5 sm:grid-cols-3  gap-[11.5px] sm:gap-[26px] mt-2">
        {product.map((item) => (
          <ProductItem product={item}></ProductItem>
        ))}
      </div>
      <div className="h-6"></div>
      {product.length > 0 && (
        <Pagination
          pageSize={10}
          current={page}
          onChange={onChange}
          total={totalPage}
          showSizeChanger={false}
        />
      )}
      <div className="h-6"></div>
      <SellingProducts></SellingProducts>
    </div>
  );
}
